import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ConnectionTemplatesFormVM } from '../../connection-template-form.viewmodel';
import { TemplatePodiumFormPresentation } from './template-podium-form.presentation';
import TemplatePodiumFormVM from './template-podium-form.viewmodel';
export type PodiumFormProps = {
    vm: ConnectionTemplatesFormVM;
};

export const TemplatePodiumForm = withViewModel(TemplatePodiumFormPresentation, async (props: PodiumFormProps) => {
    const formVm = new TemplatePodiumFormVM(props.vm);
    formVm.initFormData();
    return formVm;
});
